import React from 'react';
import ShareWebOutlineIcon from './share-web-outline';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ShareIcon(props) {
  return ___EmotionJSX(ShareWebOutlineIcon, props);
}